export default __webpack_public_path__ + "7e7f4dcae7.svg";